import styled, { css } from 'styled-components';
import { pxToRem } from '@soluto-private/mx-asurion-ui-react';
export const CarouselWrapper = styled.div.withConfig({
  displayName: "CarouselWrapper",
  componentId: "asurion-ui-react__sc-s4ss5o-0"
})(["position:relative;display:flex;flex-direction:column;gap:1rem;"]);
export const CarouselContainer = styled.ul.withConfig({
  displayName: "CarouselContainer",
  componentId: "asurion-ui-react__sc-s4ss5o-1"
})(["display:grid;grid-auto-flow:column;grid-template-rows:auto;grid-auto-columns:", ";list-style-type:none;padding-left:0;", " ", ";overflow-x:auto;scroll-snap-type:x mandatory;scroll-snap-stop:always;scroll-behavior:", ";& > *{scroll-snap-align:start;}-webkit-overflow-scrolling:touch;scrollbar-width:none;&::-webkit-scrollbar{display:none;}"], ({
  $elementWidth
}) => $elementWidth, props => `margin: 0 calc((${props.$elementWidth} + 1rem) * -${props.$bleedElements});`, ({
  $variant
}) => $variant !== 'page' && 'column-gap: 1rem;', ({
  $isPlaywright
}) => $isPlaywright ? 'auto' : 'smooth');
export const StyledCarouselSlide = styled.div.withConfig({
  displayName: "StyledCarouselSlide",
  componentId: "asurion-ui-react__sc-s4ss5o-2"
})(["display:grid;grid-auto-flow:column;grid-template-rows:auto;grid-auto-columns:", ";grid-column:span ", ";column-gap:1rem;list-style-type:none;padding-left:0;"], ({
  $elementWidth
}) => $elementWidth, ({
  $span
}) => $span);
export const ButtonWrapper = styled.div.withConfig({
  displayName: "ButtonWrapper",
  componentId: "asurion-ui-react__sc-s4ss5o-3"
})(["display:flex;transition:opacity 0.25s ease-in-out;flex-direction:row;justify-content:space-between;gap:1rem;", ""], ({
  $isRelative
}) => $isRelative && css(["position:absolute;top:calc(50% - 2.25rem);left:-1rem;right:-1rem;"]));
export const Footer = styled.div.withConfig({
  displayName: "Footer",
  componentId: "asurion-ui-react__sc-s4ss5o-4"
})(["display:flex;flex-direction:row;justify-content:space-between;align-items:flex-start;height:2rem;gap:1rem;"]);
export const IndicatorContainer = styled.div.withConfig({
  displayName: "IndicatorContainer",
  componentId: "asurion-ui-react__sc-s4ss5o-5"
})(["box-sizing:border-box;display:flex;gap:0.5rem;max-width:calc(100% - ", "rem);"], pxToRem(96));
export const Indicator = styled.div.withConfig({
  displayName: "Indicator",
  componentId: "asurion-ui-react__sc-s4ss5o-6"
})(["width:2.5rem;height:0.25rem;background-color:", ";border-radius:999px;transition:background-color 0.25s ease-in-out;"], ({
  $isActive
}) => $isActive ? 'var(--aui-outline)' : 'var(--aui-outline-soft)');